import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/main',
        name: 'Home',
        component: () => import('../views/Home.vue'),
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
    },
    {
        path: '/stage',
        name: 'Stage',
        component: () => import('../views/Stage/index.vue'),
        children: [
            {
                path: 'select/:type',
                name: 'Stage_Select',
                component: () => import('../views/Stage/Select.vue'),
            },
            {
                path: 'game/:type/:level',
                name: 'Stage_Game',
                component: () => import('../views/Stage/Game.vue'),
            },
            {
                path: 'game/:type/:level/result',
                name: 'Stage_Result',
                component: () => import('../views/Stage/Result.vue'),
            },
            {
                path: '/tower/:type/:level/review',
                name: 'Stage_Review',
                component: () => import('../views/Stage/Review.vue'),
            },
            {
                path: '/tower/:type/:level',
                name: 'Stage_Tower',
                component: () => import('../views/Stage/Tower.vue'),
            },
            {
                path: 'comics',
                name: 'Stage_Comics_Menu',
                component: () => import('../views/Stage/Comics/Menu.vue'),
            },
            {
                path: 'comics/:level',
                name: 'Stage_Comics',
                component: () => import('@/views/Stage/Comics/Comics.vue'),
            },
            {
                path: 'comics/:level/question',
                name: 'Stage_Comic_Question',
                component: () => import('../views/Stage/Comics/ComicQuestion.vue'),
            },
        ],
    },
    {
        path: '/join/event/:eventId',
        name: 'JoinEvent',
        component: () => import('../views/Home.vue'),
    },
    {
        path: '*',
        redirect: { name: 'Login' },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
